<template>
    <div class="wk-detail">
        <div class="video-box">
            <a href="javascript:history.go(-1);" class="back" v-if="isUa">
                <i class="el-icon-arrow-left"></i>
            </a>
            <div :class="{'fixed': isFixed}">
                <Video :lesson="lesson" :playurl="playurl"></Video>
            </div>
        </div>
        <Message :msg="lesson"></Message>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp';
import Video from "./video"
import Message from "./message"
import Loading from "../loading"

export default{
    name: 'WkDetail',
    data(){
        return{
            id: '',
            isLoading: false,
            isUa: false,
            isFixed: false,
            lesson: {},
            name: this.$route.params.name,
            resId: this.$route.params.resId,
            list: [],
            playurl:''
        }
    },
    created(){
        this.isUa = window.navigator.userAgent.indexOf('ZgApp') >= 0 && window.navigator.userAgent.indexOf('Android') >= 0 ? true : false;
        //this.getContent();
    },
    mounted () {
        this.getContent();
        this.$nextTick(() => {
            if(this.isPhone()){
                window.addEventListener("scroll", () => {
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                    this.isFixed = scrollTop > 200 && this.video !== null;
                });
            }
        });
    },
    computed:{
        isTip(){
            return this.lesson.title.indexOf('预告') < 0
        }
    },
    methods:{
        getContent(){
            this.isLoading = true;
            jsonp(`http://byte.gxnews.com.cn/php/qdapi.php?action=detail&resId=${this.$route.params.resId}`, {} , (err, data) => {
                this.isLoading = false;
                this.lesson = {
                    id:data.data.id,
                    url:data.data.downloadURL,
                    speaker:data.data.speaker,
                    poster:data.data.iconURL,
                    title:data.data.title,
                    resTime:data.data.resTime,
                    clickTimes:data.data.clickTimes,
                    collectTimes:data.data.collectTimes,
                    likeTimes:data.data.likeTimes
                }
                this.playurl = 'http://final.tfedu.net/nas/'+data.data.fpath+'/'+data.data.fname;
            });
            
            let pvSortid = '';
            let myurl = `http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fwktetail%2f${encodeURI(this.$route.params.name)}%2f${this.$route.params.resId}`;
            document.title = this.lesson.title;
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${myurl}&sid=${pvSortid}&aid=${this.$route.params.resId}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            });
        },
        isPhone(){
            let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return mobile!= null
        }
    },
    components:{
        Video,
        Message,
        Loading
    },
}
</script>

<style lang="less" scoped>
    .video-box{
        position: relative;
        background: url("../../assets/images/mingshi_banner.jpg") no-repeat;
        background-size: 100%;
        padding: 43% 0.3rem 0 0.3rem;
        .back{
            border-radius: 50%;
            background: rgba(0,0,0,0.2);
            display: block;
            position: absolute;
            left: 0.5rem;
            top: 0.5rem;
            z-index: 10;
            color: #fff;
            width: 0.7rem;
            height: 0.7rem;
            line-height: 0.7rem;
            text-align: center;
            font-size: 0.5rem;
        }
        i{
            font-weight: bold;
        }
    }
    .wk-detail-info{
        padding: 0.3rem 0 0.45rem 0;
        border-bottom: 0.2rem solid #f3f3f3;
    } 
    .no-class-data{
        text-align: center;
        p{
            margin-bottom: 0.25rem;
            font-size: 0.26rem;
            color: #888;
        }
        img{
            width: 12%;
        }
    }             
</style>   